/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
// Public API for util
var decorators_1 = require('./util/decorators');
exports.Class = decorators_1.Class;
//# sourceMappingURL=util.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/@angular/core/src/util.js
 ** module id = 277
 ** module chunks = 0
 **/